export default {
  searchText(state) {
    return state.searchText;
  },
  stringFilter(state) {
    if (state.searchText) {
      return `(nome like '%${state.searchText.toLowerCase()}%')`;
    }
    return '';
  },
};
